import { getApplicationDomain } from '../constants/apiEnvironments';
import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { getQueryParam } from '../routing/getQueryParam';
import { getHublet, getIsNewPortalCreated } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const getGoogleWorkspaceAppRedirect = state => {
  var _window$opener;
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const stateQueryParam = getQueryParam('state');
  const appDomain = getApplicationDomain();
  const isNewPortal = getIsNewPortalCreated(state);
  (_window$opener = window.opener) === null || _window$opener === void 0 || _window$opener.postMessage({
    type: 'GOOGLE_WORKSPACE_SIGNUP_REDIRECT',
    portalId,
    hublet,
    isNewPortal
  }, appDomain);
  return makeLinkWithQueryParams({
    hublet,
    queryParamsToInclude: {
      state: stateQueryParam,
      isNewPortal
    },
    link: `${getApplicationDomain(hublet)}/hubspot-for-sheets/${portalId}/connect`
  });
};